// Main JavaScript entry point for Tabayer custom theme
import "../scss/main.scss";
import { initPdpMobileCarousel } from "./pdp-mobile-carousel";
import { initPdpPurchaseOptions } from "./pdp-purchase-options";

document.addEventListener("DOMContentLoaded", () => {
  const privateClientTool = document.querySelector(
    "[data-private-client-tool]",
  );

  if (!privateClientTool) {
    return;
  }

  const openButton = privateClientTool.querySelector(
    ".private-client-tool-button",
  );
  const content = privateClientTool.querySelector(
    ".private-client-tool-content",
  );
  const closeButton = privateClientTool.querySelector(
    ".private-client-tool-content-close",
  );
  const optionLinks = privateClientTool.querySelectorAll(
    ".private-client-tool-options a",
  );

  if (!openButton || !content || !closeButton) {
    return;
  }

  const setIsOpen = (isOpen) => {
    privateClientTool.classList.toggle("is-open", isOpen);
    openButton.setAttribute("aria-expanded", String(isOpen));
    content.setAttribute("aria-hidden", String(!isOpen));
  };

  openButton.addEventListener("click", () => {
    setIsOpen(!privateClientTool.classList.contains("is-open"));
  });

  closeButton.addEventListener("click", () => {
    setIsOpen(false);
  });

  optionLinks.forEach((link) => {
    link.addEventListener("click", () => {
      setIsOpen(false);
    });
  });

  document.addEventListener("click", (event) => {
    if (!privateClientTool.classList.contains("is-open")) {
      return;
    }

    if (!privateClientTool.contains(event.target)) {
      setIsOpen(false);
    }
  });

  const scrollBottomThreshold = 8;

  const updateScrollBottomState = () => {
    const atBottom =
      window.innerHeight + window.scrollY >=
      document.documentElement.scrollHeight - scrollBottomThreshold;

    openButton.classList.toggle("is-at-page-bottom", atBottom);
  };

  updateScrollBottomState();
  window.addEventListener("scroll", updateScrollBottomState, { passive: true });
  window.addEventListener("resize", updateScrollBottomState, { passive: true });
});

document.addEventListener("DOMContentLoaded", () => {
  const editorialVideos = document.querySelectorAll(".editorial-media-video");

  if (!editorialVideos.length) {
    return;
  }

  const prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;

  editorialVideos.forEach((video) => {
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
  });

  if (prefersReducedMotion) {
    return;
  }

  if (!("IntersectionObserver" in window)) {
    editorialVideos.forEach((video) => {
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === "function") {
        playPromise.catch(() => {});
      }
    });
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target;

        if (entry.isIntersecting && entry.intersectionRatio >= 0.35) {
          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === "function") {
            playPromise.catch(() => {});
          }
        } else {
          video.pause();
        }
      });
    },
    {
      threshold: [0, 0.35, 0.75],
      rootMargin: "0px 0px 10% 0px",
    },
  );

  editorialVideos.forEach((video) => observer.observe(video));
});

document.addEventListener("DOMContentLoaded", () => {
  document
    .querySelectorAll(".product-form__linked-siblings")
    .forEach((block) => {
      const label = block.querySelector(".product-form__variation-current");
      const thumbs = block.querySelector(
        ".product-form__linked-siblings-thumbs",
      );
      if (!label || !thumbs) return;

      const defaultText = label.textContent;

      thumbs.addEventListener("mouseover", (e) => {
        const item = e.target.closest(".product-form__linked-sibling");
        if (!item || !thumbs.contains(item)) return;

        if (item.classList.contains("product-form__linked-sibling--current")) {
          label.textContent = defaultText;
          return;
        }

        const desc = item.dataset.siblingDescription;
        if (desc !== undefined) {
          label.textContent = desc;
        }
      });

      thumbs.addEventListener("mouseout", (e) => {
        const item = e.target.closest(".product-form__linked-sibling");
        if (!item || !thumbs.contains(item)) return;

        const next = e.relatedTarget;
        if (next && thumbs.contains(next)) return;

        label.textContent = defaultText;
      });
    });
});

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    initPdpMobileCarousel();
  }, 100);

  initPdpPurchaseOptions();
});

window.addEventListener("load", () => {
  setTimeout(() => {
    initPdpMobileCarousel();
  }, 100);
});
